import React, { useEffect, useState } from "react";
import { Nav, NavItem } from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import "./Index.scss";
import { useSelector } from "react-redux";

function NavigateComponent(props) {
  let nav = useNavigate();
  const location = useLocation();
  const [pathname, setPathname] = useState();
  let TopMenuList = useSelector((state) => state.setting?.TopMenuList);
  useEffect(() => {
    setPathname(location?.pathname);
    // eslint-disable-next-line
  }, [location]);
  const handleSidebar = (menuUrl) => {
    props?.closeSideNav();
    nav(menuUrl, { replace: true });
  };
  const isExternalURL = (url) => {
    try {
      const parsed = new URL(url);
      return parsed.protocol === "http:" || parsed.protocol === "https:";
    } catch (e) {
      return false; // It's likely a relative internal route
    }
  };

  return (
    <>
      <Nav
        navbar
        className="header_item"
        style={{
          display: "flex",
          listStyle: "none",
          justifyContent: "space-around",
        }}
      >
        {TopMenuList?.filter((x) => x.old !== true)?.map((menu, i) =>
          isExternalURL(menu.menuUrl) ? (
            <NavItem className="header_active" key={i}>
              <a
                href={menu.menuUrl}
                target="_blank"
                className="header_link"
                rel="noopener noreferrer"
              >
                {menu?.menuName}
              </a>
            </NavItem>
          ) : (
            <NavItem className="header_active" key={i}>
              <div
                // to={menu?.menuUrl}
                onClick={() => handleSidebar(menu?.menuUrl)}
                className={`header_link ${
                  pathname?.split("/")[1] === menu?.menuUrl?.split("/")[1]
                    ? "active"
                    : ""
                }`}
              >
                {menu?.menuName}
              </div>
            </NavItem>
          )
        )}
        {/* <NavItem className="header_active">
          <NavLink
            to="/dashboard"
            className={`header_link ${
              pathname === "/dashboard" ? "active" : ""
            }`}
          >
            Dashboard
          </NavLink>
        </NavItem>
        <NavItem className="header_active">
          <NavLink
            to="/ceu-courses"
            className={`header_link ${
              pathname === "/ceu-courses" ? "active" : ""
            }`}
          >
            CEU Courses
          </NavLink>
        </NavItem> */}
        {/* <NavItem className="header_active">
          <NavLink
            to="/recipe"
            className={`header_link ${pathname === "/recipe" ? "active" : ""}`}
          >
            Recipe
          </NavLink>
        </NavItem> */}
        {/* <NavItem className="header_active">
          <NavLink
            to="/fig-lifestyle"
            className={`header_link ${
              pathname === "/fig-lifestyle" ? "active" : ""
            }`}
          >
            FIG Lifestyle
          </NavLink>
        </NavItem>{" "}
        <NavItem className="header_active">
          <NavLink
            to="/community"
            className={`header_link ${
              pathname === "/community" ? "active" : ""
            }`}
          >
            Community
          </NavLink>
        </NavItem>
        <NavItem className="header_active">
          <NavLink
            to="/fig-family"
            className={`header_link ${
              pathname === "/fig-family" ? "active" : ""
            }`}
          >
            FIG Family
          </NavLink>
        </NavItem>
        <NavItem className="header_active">
          <NavLink
            to="/preferred-partners"
            className={`header_link ${
              pathname === "/preferred-partners" ? "active" : ""
            }`}
          >
            Preferred Partners
          </NavLink>
        </NavItem>
        <NavItem className="header_active">
          <NavLink
            to="/reports"
            className={`header_link ${pathname === "/reports" ? "active" : ""}`}
          >
            Reports
          </NavLink>
        </NavItem>{" "}
        <NavItem className="header_active">
          <NavLink
            to="/settings"
            className={`header_link ${
              pathname === "/settings" ? "active" : ""
            }`}
          >
            Settings
          </NavLink>
        </NavItem> */}
        {/* <NavItem className="header_active">
          <NavLink
            to="/training"
            className={`header_link ${
              pathname === "/training" ? "active" : ""
            }`}
          >
            Training
          </NavLink>
        </NavItem> */}
      </Nav>
    </>
  );
}

export default React.memo(NavigateComponent);
